import { AddressDTO, EmailDTO, NoteDTO, PersonDTO, PhoneNumberDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { CompanyMode } from '../../shared/constants-and-enums/company-mode.enum';

export enum PersonActionTypes {
    LoadPersonsByCompany = '[Person] Load Persons By Company',
    LoadPersonsSuccess = '[Person] LoadAllPersonsSuccess',
    LoadPersonsFailure = '[Person] LoadAllPersonsFailure',

    LoadAllPersonsByCentralRegulator = '[Regulators] Load All Persons By Central Regulator',
    LoadAllPersonsByCentralRegulatorSuccess = '[Regulators] Load All Persons By Central Regulator Success',
    LoadAllPersonsByCentralRegulatorFailure = '[Regulators] Load All Persons By Central Regulator Failure',

    DeletePerson = '[Person] DeletePerson',
    DeletePersonSuccess = '[Person] DeletePersonSuccess',
    DeletePersonFailure = '[Person] DeletePersonFailure',

    UpsertPerson = '[Person] UpsertPerson',
    UpsertPersonSuccess = '[Person] UpsertPersonSuccess',

    PersonActionFailure = '[Person] PersonActionFailure',

    ReloadPerson = '[Person] ReloadPerson',
    ReloadPersonSuccess = '[Person] ReloadPersonSuccess',

    UpsertPersonEmail = '[Person] UpsertPersonEmail',
    RemovePersonEmail = '[Person] RemovePersonEmail',

    UpsertPersonPhoneNumber = '[Person] UpsertPersonPhoneNumber',
    RemovePersonPhoneNumber = '[Person] RemovePersonPhoneNumber',

    UpsertPersonAddress = '[Person] UpsertPersonAddress',
    RemovePersonAddress = '[Person] RemovePersonAddress',

    UpsertPersonNote = '[Person] UpsertPersonNote',
    RemovePersonNote = '[Person] RemovePersonNote'
}

export const LoadPersonsByCompany = createAction(PersonActionTypes.LoadPersonsByCompany, props<{ companyId: string }>());

export const LoadPersonsSuccess = createAction(
    PersonActionTypes.LoadPersonsSuccess,
    props<{ persons: PersonDTO[]; companyId?: string; officeId?: string }>()
);
export const LoadPersonsFailure = createAction(PersonActionTypes.LoadPersonsFailure, props<{ error: any }>());

export const UpsertPerson = createAction(PersonActionTypes.UpsertPerson, props<{ person: PersonDTO; mode: CompanyMode }>());
export const UpsertPersonSuccess = createAction(PersonActionTypes.UpsertPersonSuccess, props<{ person: PersonDTO }>());

export const UpsertPersonNote = createAction(PersonActionTypes.UpsertPersonNote, props<{ personId: string; note: NoteDTO }>());
export const RemovePersonNote = createAction(PersonActionTypes.RemovePersonNote, props<{ noteId: string; personId: string }>());

export const UpsertPersonAddress = createAction(PersonActionTypes.UpsertPersonAddress, props<{ personId: string; address: AddressDTO }>());
export const RemovePersonAddress = createAction(PersonActionTypes.RemovePersonAddress, props<{ addressId: string; personId: string }>());

export const ReloadPerson = createAction(PersonActionTypes.ReloadPerson, props<{ personId: string }>());
export const ReloadPersonSuccess = createAction(PersonActionTypes.ReloadPersonSuccess, props<{ person: PersonDTO }>());

export const PersonActionFailure = createAction(PersonActionTypes.PersonActionFailure, props<{ error: any }>());

export const UpsertPersonEmail = createAction(PersonActionTypes.UpsertPersonEmail, props<{ personId: string; email: EmailDTO }>());
export const RemovePersonEmail = createAction(PersonActionTypes.RemovePersonEmail, props<{ emailId: string; personId: string }>());

export const UpsertPersonPhoneNumber = createAction(
    PersonActionTypes.UpsertPersonPhoneNumber,
    props<{ personId: string; phoneNumber: PhoneNumberDTO }>()
);
export const RemovePersonPhoneNumber = createAction(
    PersonActionTypes.RemovePersonPhoneNumber,
    props<{ phoneNumberId: string; personId: string }>()
);

export const DeletePerson = createAction(PersonActionTypes.DeletePerson, props<{ personId: string }>());
export const DeletePersonSuccess = createAction(PersonActionTypes.DeletePersonSuccess, props<{ personId: string }>());
export const DeletePersonFailure = createAction(PersonActionTypes.DeletePersonFailure, props<{ error: any }>());

export const LoadAllPersonsByCentralRegulator = createAction(
    PersonActionTypes.LoadAllPersonsByCentralRegulator,
    props<{ centralRegulatorId: string }>()
);
export const LoadAllPersonsByCentralRegulatorSuccess = createAction(
    PersonActionTypes.LoadAllPersonsByCentralRegulatorSuccess,
    props<{ persons: PersonDTO[]; centralRegulatorId: string }>()
);
export const LoadAllPersonsByCentralRegulatorFailure = createAction(
    PersonActionTypes.LoadAllPersonsByCentralRegulatorFailure,
    props<{ error: any }>()
);
